// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-data-page',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        process: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        page: {
            type: Object,
            required: false,
            default: {}
        },
    },
    computed: {
        uploadUrlFile() {
            return '/frontend/v1/forms/Processes/' + this.schema.processID + '/files?source=form';
        }
    },
    data: () => ({
        _isWorking: false,
    }),
    // #endregion
    // #region Core
    methods: {
        onGotoHome() {
            this.$router.push({ path: "/ozg" });
        },
        onCommand(command, args) {
            //Init
            this._isWorking = true;
            //Run
            this.$emit('command', command, args, () => { this._isWorking = false; });
        },
    },
    // #endregion
});
// #endregion
